import { createContext, useContext } from 'react'

import { isModuleWindow } from './desktop.ts'

/**
 * Qual moldura desenha as telas desta árvore — F138.
 *
 * Antes era `isModuleWindow()` lido direto da URL global dentro da rota. Isso
 * servia enquanto cada página tinha um endereço só; no Modo PC com janelas
 * internas, várias telas convivem na mesma página, cada uma com a navegação
 * dela, e "qual é a minha moldura" deixa de ser uma pergunta que a barra de
 * endereço sabe responder. Um contexto responde por árvore.
 *
 * - `page`: a página — o Modo Site, ou a área de trabalho do Modo PC.
 * - `window`: uma janela da área de trabalho, com o roteador dela.
 * - `native-module`: a janela nativa da F004, aberta com `?window=module`.
 *   Continua existindo, sem quem a abra (ADR-0037).
 */
export type ShellFrame =
  | { readonly kind: 'page' }
  | { readonly kind: 'window'; readonly windowId: string }
  | { readonly kind: 'native-module' }

const PAGE: ShellFrame = { kind: 'page' }

export const ShellFrameContext = createContext<ShellFrame>(PAGE)

export const useShellFrame = (): ShellFrame => useContext(ShellFrameContext)

/**
 * A moldura da página que acabou de carregar.
 *
 * Lida uma vez, na partida: a janela nativa nasce com `?window=module` e nunca
 * deixa de ser o que é. A leitura nunca foi reativa — navegar dentro dela e
 * perder o parâmetro não a transformava em outra coisa até recarregar — e
 * continua não sendo, agora de propósito e num lugar só.
 */
export const bootShellFrame = (): ShellFrame =>
  isModuleWindow() ? { kind: 'native-module' } : PAGE
